import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import Gun from "../../Gun";
import Player from "../../Player";

export default class PulseBlaster extends Gun {
    constructor(player: Player) {
        super(player, {
            damage: 15,
            fireRate: 8,
            reloadTime: 2,
            bulletSpeed: 200,
            magSize: 30,
            mouseTrigger: 0
        });
    }

    onShoot(): void {
        const centerSpawnPos = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size + 4));
        const vel = this.player.velocity.add(this.player.transform.forward.scale(this.bulletSpeed));

        this.player.engine.createBulletForAll(centerSpawnPos, vel, [
            {
                key: "team",
                value: this.player.team || "",
                type: PacketValueSerialType.String
            },
            {
                key: "damage",
                value: this.damage,
                type: PacketValueSerialType.Byte
            },
            {
                key: "ownerName",
                value: this.player.name,
                type: PacketValueSerialType.String
            },
        ]);
    }
}